import React, { useState, useMemo, forwardRef, useRef, useImperativeHandle, useEffect } from "react";
import { CreateNewFieldStyle, CreateNewFieldType, NewFieldStyles, NewFieldTypes } from "../../Definitions/newFieldStyles";
import { colors, fonts, glyphs } from "../../Styles";
import { CreateListStyle, ListStyle_Types } from "../../Definitions";
import { styled } from "styletron-react";
import { useDateFormat } from "../_Components";
import { debounce } from "lodash";

// const calendarIcon = (
//   <svg height="20" width="20" fill={colors.systemGreen} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
//   <rect x="23.39" y="33.46" width="236.68" height="236.68" rx="21.83" ry="21.83"/>
//   <g>
//     <path d="M126.94,226.9c1.9-1.08,3.27-3.06,4.11-5.94.84-2.88,1.26-6.98,1.26-12.3v-7.98l-10.9-5.41v14.91h-34.32l34.71-36.1c2.12-2.28,3.69-4.18,4.7-5.7,1.01-1.52,1.75-3.42,2.24-5.7.48-2.28.73-5.38.73-9.31v-6.36c0-5.32-.43-9.42-1.29-12.3-.86-2.88-2.23-4.86-4.11-5.94-1.88-1.08-4.59-1.61-8.13-1.61h-30.35c-3.5,0-6.2.54-8.11,1.61-1.9,1.08-3.27,3.06-4.11,5.94-.84,2.88-1.26,6.98-1.26,12.3v13.2l11.68,5.03v-20.8h33.65v13.01l-40.86,43.41c-2.2,2.34-3.84,4.46-4.92,6.36-1.08,1.9-1.78,3.72-2.1,5.46-.32,1.74-.48,3.97-.48,6.7v9.12h49.69c3.54,0,6.26-.54,8.16-1.61Z"/>
//     <path d="M162.95,228.51h37.76c5.56,0,9.35-1.61,11.38-4.84,2.03-3.23,3.05-8.87,3.05-16.91v-10.73c0-6.14-1.03-10.86-3.11-14.15-2.07-3.29-5.23-5.32-9.48-6.08,4.18-1.46,7.1-3.61,8.76-6.46,1.66-2.85,2.49-7.25,2.49-13.2v-9.12c0-5.32-.43-9.42-1.29-12.3-.86-2.88-2.23-4.86-4.11-5.94-1.88-1.08-4.6-1.61-8.14-1.61h-36.87c-3.54,0-6.26.54-8.14,1.61-1.88,1.08-3.25,3.06-4.11,5.94-.86,2.88-1.29,6.98-1.29,12.3v9.12c0,3.99.37,7.25,1.12,9.78.75,2.53,1.92,4.56,3.52,6.08,1.6,1.52,3.84,2.79,6.71,3.8-8.39,1.52-12.59,8.26-12.59,20.23v10.73c0,8.11,1.01,13.76,3.02,16.96,2.01,3.2,5.78,4.8,11.3,4.8ZM162.34,153.66c0-3.61.38-6.05,1.15-7.31.76-1.27,2.3-1.9,4.62-1.9h27.58c2.27,0,3.79.63,4.53,1.9.75,1.27,1.12,3.7,1.12,7.31v5.03c0,3.67-.37,6.14-1.12,7.41-.75,1.27-2.26,1.9-4.53,1.9h-27.58c-2.31,0-3.85-.63-4.62-1.9-.77-1.27-1.15-3.74-1.15-7.41v-5.03ZM161.1,193.65c0-3.61.36-6.03,1.09-7.27.73-1.23,2.23-1.85,4.5-1.85h30.27c2.27,0,3.78.6,4.5,1.8.73,1.2,1.09,3.64,1.09,7.31v7.6c0,3.61-.36,6-1.09,7.17-.73,1.17-2.23,1.76-4.5,1.76h-30.27c-1.53,0-2.69-.22-3.5-.66-.8-.44-1.35-1.3-1.65-2.56-.3-1.27-.45-3.17-.45-5.7v-7.6Z"/>
//     <path d="M241.18,30.65h-19.41v18.04c0,7.38-6,13.38-13.38,13.38h-1.24c-7.38,0-13.38-6-13.38-13.38v-18.04h-103.3v18.04c0,7.38-6,13.38-13.38,13.38h-1.24c-7.38,0-13.38-6-13.38-13.38v-18.04h-19.41c-12.32,0-22.34,10.02-22.34,22.34v198.12c0,12.32,10.02,22.34,22.34,22.34h198.12c12.32,0,22.34-10.02,22.34-22.34V52.98c0-12.32-10.02-22.34-22.34-22.34ZM256.51,251.1c0,8.46-6.88,15.34-15.34,15.34h-10.09l25.43-25.43v10.09ZM256.51,225.02h-23.66c-1.2-.05-8.6-.06-13.32,5.99-4.43,5.68-4.38,9.74-4.35,11.91v23.52s-172.12,0-172.12,0c-8.46,0-15.34-6.88-15.34-15.34V105.64h228.79v119.38Z"/>
//     <rect x="63.97" y="13.32" width="25" height="47.07" rx="11.88" ry="11.88"/>
//     <path d="M207.15,13.32h1.24c6.56,0,11.88,5.32,11.88,11.88v23.31c0,6.56-5.32,11.88-11.88,11.88h-1.24c-6.56,0-11.88-5.32-11.88-11.88v-23.31c0-6.56,5.32-11.88,11.88-11.88Z"/>
//   </g>
// </svg>
// )

// #region | Styled Input
// Prefixed with $dollar sign see: https://styled-components.com/docs/api#transient-props
interface StyledInputProps {
  fontSize?: string;
  $fontColor?: string;
  $primaryColor?: string;
  secondaryColor?: string;
  width?: string;
  height?: string
  $containerPadding?: string;
  type?: string
}

export const StyledInput = styled<"input", StyledInputProps>("input", (props) => ({
  height: props.height,
  width: props.width,
  boxSizing: "border-box",
  borderRadius: "10px",
  border: "none",
  backgroundColor: props.$primaryColor,
  outline: "none",
  fontFamily: "Inter Flex",
  fontWeight: "300",
  fontSize: "12px",
  lineHeight: "normal",
  margin: "0",
  textTransform: "none",
  padding: props.$containerPadding,
  color: props.$fontColor || colors.greyLightTertiary,
  "::placeholder": {
    color: props.$fontColor || colors.greyPrimary,
    filter: "opacity(0.5)"
  },
  ":-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus": {
    WebkitTextFillColor: props.$fontColor,
    transition: "background-color 5000s ease-in-out 0s",
    boxShadow: `0 0 0px 1000px ${props.$primaryColor} inset`,
  },
  "::-webkit-inner-spin-button": {
    "-webkit-appearance": "none"
  },
  "::-webkit-outer-spin-button": {
    "-webkit-appearance": "none"
  },
  "input[type=number]": {
    "-moz-appearance": "textfield"
  },
  "input[type=date i]::-webkit-calendar-picker-indicator": {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    width: "auto",
    height: "auto",
    color: "transparent",
    background: "transparent",
    cursor: "pointer"
  },
  ":disabled": {
    color: props.$fontColor + "ab",
    cursor: "not-allowed",
    backgroundColor: props.$primaryColor + "52"
  },
  ...(props.type === "date" && {
    color: "transparent",
    backgroundColor: "transparent",
    zIndex: "1",
    position: "relative"
  }),
}));
// #endregion

/* eslint-disable */
// ValueSteps for valueStep/inputfield step
export enum ValueSteps {
  integers = "integers",
  floats = "floats"
}
/* eslint-enable */

// #region | New Input
export interface NewInputHandles {
  value: string | number;
  setValue: (e: string | number) => void;
  setError: (state?:boolean) => void
}
interface newInputProps {
  onChange?: (e: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  header?: string;
  startEnhancer?: JSX.Element;
  isRequired?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  fieldOverrides?: {
    fieldStyle?: NewFieldStyles;
    fieldType?: NewFieldTypes;
    fieldWidth?: string;
    disabledNoInput?: boolean
  };
  valueOverrides?: {
    defaultValue?: string | number;
    valueType?: string;
    valueStep?: ValueSteps;
    minValueNumber?: number;
    maxValueNumber?: number;
  };
}
/**
 * NewInput
 * @param placeholder The placeholder text displayed in the input field.
 * @param defaultValue The initial value of the input field.
 * @param startEnhancer An optional element displayed at the start of the input field.
 * @param isRequired Indicates whether the input field is required.
 * @param isClearable Determines if the input field can be cleared via a button.
 * @param isDisabled Disables the input field.
 * @param fieldOverrides Custom styling and width settings for the input field.
 * @param valueOverrides Default values and settings for the input field.
 * @returns A styled input component with optional start enhancer and clear functionality.
 */
const _NewInput: React.ForwardRefRenderFunction<NewInputHandles, newInputProps> = ({ onChange, onBlur, placeholder, header, startEnhancer, isRequired = false, isClearable = false, isDisabled = false, fieldOverrides, valueOverrides }: newInputProps, ref) => {
  const [isDecreasingHovered, setIsDecreasingHovered] = useState<boolean>(false); 
  const [isIncreasingHovered, setIsIncreasingHovered] = useState<boolean>(false); 
  const [, setError] = useState(false)
  const [shouldTriggerSpinnerBlur, setShouldTriggerSpinnerBlur] = useState(false);
  const [isClearHovered, setIsClearHovered] = useState(false);
  const [inputValue, setInputValue] = useState((valueOverrides?.defaultValue || valueOverrides?.defaultValue === 0) ? valueOverrides.defaultValue : "" );
  const _placeholder = placeholder ? placeholder + "..." : "...";
  const _headerShadow = fieldOverrides && fieldOverrides.fieldStyle === NewFieldStyles.greyTertiary ? undefined : { ...fonts.textShadow };
  const {formatDateForDisplay} = useDateFormat()

  useEffect(() => {
    if (shouldTriggerSpinnerBlur && onBlur) {
      setShouldTriggerSpinnerBlur(false);
      onBlur()
    }
  },[onBlur, shouldTriggerSpinnerBlur])

  const debouncedSetTriggerBlurState = debounce(() => {
    setShouldTriggerSpinnerBlur(true);
  }, 1000)

  useEffect(() => { // TODO Could be removed if loading states were introduced through out the web panel 
    if (valueOverrides && (valueOverrides.defaultValue || valueOverrides.defaultValue === 0)) {
      setInputValue(valueOverrides.defaultValue)
    }
  },[valueOverrides])

  useImperativeHandle(ref, () => ({
    setError(state=true) {
      setError(state)
    },
    value: inputValue,
    setValue: (e: string | number) => { setInputValue(e as string); }
  }));

  const handleClear = () => {
    setInputValue("");
  };

  // FieldStyle
  const { primaryColor, secondaryColor, fontColor, headerColor } = useMemo(() => {
    var _Style = CreateNewFieldStyle(fieldOverrides?.fieldStyle);
    return _Style;
  }, [fieldOverrides?.fieldStyle]);

  const { containerPaddingTop, containerPaddingRight, containerPaddingBottom, containerPaddingLeft, height } = useMemo(() => {
    var _Style = CreateNewFieldType(fieldOverrides?.fieldType);
    return _Style;
  }, [fieldOverrides?.fieldType]);

  const _fieldWidth = fieldOverrides && fieldOverrides.fieldWidth !== undefined ? fieldOverrides.fieldWidth : "280px";

  // Date input
  const isDateType = valueOverrides?.valueType === "date";
  const showDatePlaceholder = isDateType && !inputValue;
  const datePlaceholder = "dd/mm/yyyy";

  // #region | Clear Button
  const clearBtn = (
    <svg onClick={handleClear}
      onMouseEnter={() => setIsClearHovered(true)}
      onMouseLeave={() => setIsClearHovered(false)}
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 20 20"
      height="20"
      width="20"
      fill={!isClearHovered ? secondaryColor : colors.greyLightTertiary}
      style={{
        transition: "fill 0.3s ease",
        cursor: "pointer",
        // padding: "8px",
      }}
    >
      <path d="M 14.348 14.849 c -0.469 0.469 -1.229 0.469 -1.697 0 l -2.651 -3.03 l -2.651 
        3.029 c -0.469 0.469 -1.229 0.469 -1.697 0 c -0.469 -0.469 -0.469 -1.229 0 -1.697 l 
        2.758 -3.15 l -2.759 -3.152 c -0.469 -0.469 -0.469 -1.228 0 -1.697 s 1.228 -0.469 
        1.697 0 l 2.652 3.031 l 2.651 -3.031 c 0.469 -0.469 1.228 -0.469 1.697 0 s 0.469 1.229 
        0 1.697 l -2.758 3.152 l 2.758 3.15 c 0.469 0.469 0.469 1.229 0 1.698 Z"
      />
    </svg>
  );
  // #endregion

  // #region | Decreasing and increasing buttons
  const decreasingSpinner = (
    <button 
      onClick={() => {
        const newValue = Number(inputValue) - 1;
        if (valueOverrides?.minValueNumber !== undefined && newValue < valueOverrides.minValueNumber) return;
        setInputValue(newValue);
        if (onChange) {onChange(String(newValue))}
        if (onBlur) {debouncedSetTriggerBlurState()}
      }}
      onMouseEnter={() => setIsDecreasingHovered(true)}
      onMouseLeave={() => setIsDecreasingHovered(false)}
      style={{transition: "fill 0.3s ease", cursor: "pointer", height: "10px", width: "20px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.transparent, border: "none", padding: "0px"}}
    >
      <glyphs.ArrowSmall fillColor={isDecreasingHovered? colors.greyLightTertiary : secondaryColor} rotate={90} size={"10px"}/>
    </button>
  )

  const increasingSpinner = (
    <button 
    onClick={() => {
      const current = Number(inputValue);
      const max = valueOverrides?.maxValueNumber ?? 2147483647;
      if (current >= max) return;
    
      const newValue = current + 1;
      setInputValue(newValue);
      if (onChange) onChange(String(newValue));
      if (onBlur) debouncedSetTriggerBlurState();
    }}
      onMouseEnter={() => setIsIncreasingHovered(true)}
      onMouseLeave={() => setIsIncreasingHovered(false)}
      style={{transition: "fill 0.3s ease", cursor: "pointer", height: "10px", width: "20px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.transparent, border: "none", padding: "0px"}}
    >
      <glyphs.ArrowSmall fillColor={isIncreasingHovered? colors.greyLightTertiary : secondaryColor} rotate={-90} size={"10px"}/>
    </button>
  )

  const spinBtns = ( 
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "2px"}}>
      {increasingSpinner}
      {decreasingSpinner}
    </div> 
  )
  // #endregion

  // #region | ValueSteps
  let valueStep = 1;

  switch (valueOverrides?.valueStep) {
    case ValueSteps.floats:
      valueStep = 0.1;
      break;
    case ValueSteps.integers:
      default:
      valueStep = 1;
      break;
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (valueOverrides?.valueStep === ValueSteps.integers || valueOverrides?.valueStep === undefined) {
      if (e.key === "." || e.key === "," || e.key === "Decimal") {
        e.preventDefault();
      }
    }
  };
  // #endregion

  return (
    <div style={{ width: _fieldWidth }}>
      {header && <p style={{ ..._headerShadow, ...fonts.header, ...fonts.fontSize4, color: headerColor, padding: "0px 0px 2px 10px" }}>{header}</p>}
      <div style={{ position: "relative" }}>
        <StyledInput
          value={inputValue}
          onKeyDown={handleKeyDown}
          step={valueStep}
          onChange={e => {
            let newValue = e.target.value;
          
            if (valueOverrides?.valueType === "number") {
              const num = Number(newValue);
          
              if (!isNaN(num)) {
                if (valueOverrides?.maxValueNumber !== undefined && num > valueOverrides.maxValueNumber) {
                  newValue = valueOverrides.maxValueNumber.toString();
                }
                if (valueOverrides?.minValueNumber !== undefined && num < valueOverrides.minValueNumber) {
                  newValue = valueOverrides.minValueNumber.toString();
                }
              }
            }
          
            setInputValue(newValue);
            if (onChange) onChange(newValue);
          }}
          onBlur={onBlur}
          placeholder={isDateType ? datePlaceholder : _placeholder}
          disabled={isDisabled}
          defaultValue={valueOverrides?.defaultValue}
          type={valueOverrides?.valueType}
          autoComplete="new-password"
          min={valueOverrides?.minValueNumber}
          max={valueOverrides?.maxValueNumber}
          $fontColor={fontColor}
          $primaryColor={(fieldOverrides&&fieldOverrides.fieldStyle === NewFieldStyles.transparent) ? colors.transparent : primaryColor}
          width={_fieldWidth}
          height={`${height}px`}
          $containerPadding={
            startEnhancer ? "6px 8px 6px 38px"
              : `${containerPaddingTop + 4}px ${containerPaddingRight + 2}px ${containerPaddingBottom + 4}px ${containerPaddingLeft + 2}px`
          }
        />

        {/* DATE FIELD */}
        {valueOverrides?.valueType === "date" ? (
          <div style={{ 
            position: "absolute", 
            zIndex: "0", 
            top: "0", 
            left: "0", 
            backgroundColor: primaryColor, 
            borderRadius: "10px",
            width: _fieldWidth, 
            height: `${height}px`, 
            boxSizing: "border-box",
            padding: startEnhancer ? "6px 8px 6px 38px" : `${containerPaddingTop + 4}px ${containerPaddingRight + 2}px ${containerPaddingBottom + 4}px ${containerPaddingLeft + 2}px`,
            display: "flex", 
            flexDirection: "row", 
            alignItems: "center", 
            justifyContent: "left",
          }}>
            <p style={{ color: fontColor, ...fonts.fontSize4, ...fonts.paragraph, filter: showDatePlaceholder ? "opacity(0.5)" : "none"}}>{showDatePlaceholder ? "dd/mm/yyyy" : formatDateForDisplay(new Date(inputValue))}</p>
          </div>
        ):<></>}
        
        {/* NUMBER FIELD (arrows) */}
        <div style={{ position: "absolute", zIndex: "99",  height: "22px", top: "50%", transform: "translateY(-50%)", right: "0px", display: "grid", gridAutoFlow: "column", gridAutoColumns: "1fr", padding: "4px 8px", alignItems: "center" }}>
          {/* {!isDisabled && isRequired && inputValue === "" ? (<glyphs.Error fillColor={colors.systemRed} />):<></>} */}
          {!isDisabled && valueOverrides?.valueType === "number" ? (<>{spinBtns}</>):<></>}
          {!isDisabled && isClearable && inputValue !== ""
            ? (<>{clearBtn}</>)
            : isClearable && isRequired && inputValue === "" ? <glyphs.Error fillColor={colors.systemRed} />
          : <></>}
        </div>
        
        {/* EMPTY FIELD */}
        {/* {!isDisabled && isRequired && inputValue === "" ? (
          <div style={{ position: "absolute", height: "20px", top: "50%", transform: "translateY(-50%)", right: "-22px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            <glyphs.Error fillColor={colors.systemRed} />
          </div>
        ):<></>} */}

        {/* STARTENHANCER */}
        {startEnhancer ? (
          <div style={{ position: "absolute", height: "20px", top: "50%", transform: "translateY(-50%)", left: "8px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            {startEnhancer}
          </div>
        ):<></>}
      </div>
    </div>
  );
};
const NewInput = forwardRef(_NewInput);
export default NewInput;
// #endregion

// #region | New Input List
export type NewInputListHandles = {
  setError: (index:number, state:boolean) => void,
  value: (index: number) => string | number | undefined;
  refs: React.MutableRefObject<NewInputHandles[]>;
}

interface newInputListProps {
  onChanges?: ((e: string) => void)[];
  placeholders?: string[];
  headers?: string[];
  startEnhancers?: JSX.Element[];
  isRequired?: boolean[];
  isClearable?: boolean;
  isDisabled?: boolean[];
  fieldOverrides?: {
    fieldStyle?: NewFieldStyles;
    fieldType?: NewFieldTypes;
    fieldWidth?: string;
  };
  valueOverrides?: {
    defaultValues?: (string | number)[];
    valueTypes?: string[];
    minValueNumbers?: number[];
    maxValueNumbers?: (number | undefined)[];
  };
  listOverrides?: {
    listGap?: string;
    listStyle?: ListStyle_Types;
  };
}
/**
 * NewInputList
 * @param placeholders An array of placeholder texts for each input field.
 * @param defaultValues An array of default values for each input field.
 * @param startEnhancers An array of elements displayed at the start of each input field.
 * @param isRequired An array indicating whether each input field is required.
 * @param isClearable Determines if each input field can be cleared via a button.
 * @param isDisabled An array indicating whether each input field is disabled.
 * @param fieldOverrides Custom styling and width settings for all input fields.
 * @param valueOverrides Default values and settings for each input field.
 * @param listOverrides Custom styling and layout settings for the list container.
 * @returns A list of styled input components with optional start enhancers and clear functionality.
 */
const _NewInputList: React.ForwardRefRenderFunction<NewInputListHandles, newInputListProps> = ({ onChanges, placeholders, headers, startEnhancers, isRequired = [false], isClearable = false, isDisabled = [false], fieldOverrides, valueOverrides, listOverrides }: newInputListProps, ref) => {
  const inputRefs = useRef<NewInputHandles[]>([]);
  const _listGap = listOverrides && listOverrides.listGap ? { gap: listOverrides.listGap } : { gap: "5px" };
  const { listDirection } = useMemo(() => CreateListStyle(listOverrides && listOverrides.listStyle), [listOverrides]);

  useImperativeHandle(ref, () => ({
    setError(index=0,state) { 
      if (inputRefs.current && inputRefs.current[index]) inputRefs.current[index].setError(state)
    },
    value(index = 0): string | number | undefined {
      if (inputRefs.current && inputRefs.current[index]) return inputRefs.current[index]?.value;
      return undefined;
    },
    refs: inputRefs
  }));

  const Item_List = useMemo(() => {
    return placeholders?.map((_placeholders, index) => {
      const _onChanges = onChanges && onChanges[index] ? onChanges[index] : undefined;
      const _headers = headers && headers[index] ? headers[index] : "";
      const _startEnhancers = startEnhancers && startEnhancers[index] ? startEnhancers[index] : undefined;
      const _isRequired = isRequired && isRequired[index] ? isRequired[index] : undefined;
      const _isDisabled = isDisabled && isDisabled[index] ? isDisabled[index] : undefined;
      const _fieldOverrides = fieldOverrides || {};
      const _defaultValues = valueOverrides && valueOverrides.defaultValues && valueOverrides.defaultValues[index] ? valueOverrides.defaultValues[index] : undefined;
      const _valueTypes = valueOverrides && valueOverrides.valueTypes && valueOverrides.valueTypes[index] ? valueOverrides.valueTypes[index] : undefined;
      const _minValueNumbers = valueOverrides && valueOverrides.minValueNumbers && valueOverrides.minValueNumbers[index] ? valueOverrides.minValueNumbers[index] : undefined;
      const _maxValueNumbers = valueOverrides && valueOverrides.maxValueNumbers && valueOverrides.maxValueNumbers[index] ? valueOverrides.maxValueNumbers[index] : undefined;

      var view = [
        <NewInput
          key={"List_Input_" + index}
          ref={(el) => el ? inputRefs.current[index] = el : null}
          onChange={_onChanges}
          placeholder={_placeholders}
          header={_headers}
          startEnhancer={_startEnhancers}
          isRequired={_isRequired}
          isClearable={isClearable}
          isDisabled={_isDisabled}
          fieldOverrides={_fieldOverrides}
          valueOverrides={{
            defaultValue: _defaultValues,
            valueType: _valueTypes,
            minValueNumber: _minValueNumbers,
            maxValueNumber: _maxValueNumbers
          }}
        />
      ];

      return view;
    });
  }, [placeholders, onChanges, headers, startEnhancers, isRequired, isDisabled, fieldOverrides, valueOverrides, isClearable]);

  return (
    <div style={{ ...listDirection as React.CSSProperties, ..._listGap }}>
      {Item_List}
    </div>
  );
}
export const NewInputList = forwardRef(_NewInputList);
// #endregion